import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const HdiCarbon3280Lvs32 = () => {
  console.log('🎯 HdiCarbon3280Lvs32 component loading');
  
  const product = findProductById("hdi-carbon-32-80-lvs32");
  
  if (!product) {
    console.error('Product not found:', "hdi-carbon-32-80-lvs32");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="hdi-carbon-32-80-lvs32"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default HdiCarbon3280Lvs32; 